import * as yup from 'yup';

const REQUIRED_MESSAGE = 'Обязательное поле';
const getLengthError = (min: number, max: number) =>
  `Значение должно быть от ${min} до ${max} символов.`;

const baseStringSchema = yup
  .string()
  .required(REQUIRED_MESSAGE)
  .min(3, getLengthError(3, 255))
  .max(255, getLengthError(3, 255));

export const gatewaySchema = yup.object().shape({
  name: baseStringSchema,
  externalAlias: baseStringSchema,
  alias: baseStringSchema,
  provider: yup.string().required(REQUIRED_MESSAGE),
  direction: yup.string().required(REQUIRED_MESSAGE),
  status: yup.string().required(REQUIRED_MESSAGE),
  defaultCurrency: yup.string().required(REQUIRED_MESSAGE),
  orderExpirationTimeSec: yup
    .number()
    .required(REQUIRED_MESSAGE)
    .integer('Значение должно быть целым числом')
    .min(1, 'Значение не может быть меньше 1'),
  transactionRequestMaxAttempts: yup.number().integer('Значение должно быть целым числом'),
  attemptIntervalConfig: yup
    .string()
    .required(REQUIRED_MESSAGE)
    .matches(/^\d+(, \d+)*$/, 'Введите последовательность чисел разделенных запятой и пробелом'),
});

export const gatewayBulkSchema = gatewaySchema.omit(['name', 'externalAlias']);

const pilotModeTimeSchema = yup.date().nullable().typeError('Введите время в формате ЧЧ:ММ');

export const gatewayEditSchema = gatewaySchema.shape({
  gatewayPilotModeSchedule: yup.object().shape({
    timeStart: pilotModeTimeSchema,
    timeEnd: pilotModeTimeSchema,
  }),
});
